import { FlexComponentBootstrap } from "../../../common/component-bootstraper";
import ColorSpotApp from "./react-color-selector-spot.jsx";
var componentName = 'color-spot';
var flexColorSpot = new FlexComponentBootstrap(componentName);
flexColorSpot.reactApp = ColorSpotApp;
flexColorSpot.run();